function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

function scrollCartDrawerToTop() {
  const cartDrawer = document.getElementById('Cart-Drawer');
  if (!cartDrawer) return;

  const scrollTarget = cartDrawer.querySelector('.side-panel-content');
  if (!scrollTarget) return;

  scrollTarget.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

/**
 *  @class
 *  @function ProductCard
 */
if (!window.ProductCard) {
  window.ProductCard = class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
      this.is_recommendation = this.classList.contains('product-card-recommendation');
      this.there_is_variant_switch_control = this.classList.contains('product-card-variant-switch-control');
    }
    connectedCallback() {
      if (this.swatches.length > 0) {
        this.swatches.forEach((swatch, indexSwatch) => {
          this.enableSwatches(swatch, this.image, indexSwatch);
        });
        this.syncActiveSwatchesState();
        this.verifySwatchAvailability();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }

    getImageSrcset(image) {
      if (!image) return '';
      return image.getAttribute('srcset') || image.dataset.srcset || '';
    }

    resolveProductCardSrcset(value) {
      if (!value) return '';
      if (/\d+w/.test(value)) return value;
      return this.buildProductCardSrcset(value);
    }

    buildProductCardSrcset(src, widths = [400, 500, 700]) {
      if (!src) return '';
      const separator = src.includes('?') ? '&' : '?';
      return widths.map((width) => `${src}${separator}width=${width} ${width}w`).join(', ');
    }

    syncActiveSwatchesState() {
      const org_srcset = this.getImageSrcset(this.image);
      this.swatches.forEach((swatchesContainer, indexSwatch) => {
        const swatch_list = swatchesContainer.querySelectorAll('.product-card-swatch');
        const activeSwatch = swatchesContainer.querySelector('.product-card-swatch.active');
        if (!activeSwatch || !swatch_list.length) return;

        this.color_index = this.swatches[indexSwatch].dataset.index;
        this.onSwatchActivate(activeSwatch, swatch_list, this.image, org_srcset);
      });
    }

    verifySwatchAvailability() {
      const selectedOptions = this.getSelectedOptionsFromSwatches();
      if (!selectedOptions.length) return;

      // Para cada opção que já tem um valor selecionado,
      // calculamos quais valores da outra opção são possíveis.
      selectedOptions.forEach((value, optionIndex) => {
        if (!value) return;
        this.updateNotExistForOption(optionIndex, selectedOptions);
      });
    }

    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }

    enableSwatches(swatches, image, indexSwatch) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = this.getImageSrcset(image);

      this.color_index = this.swatches[indexSwatch].dataset.index;

      swatch_list.forEach((swatch, index) => {
        this.preloadSwatchImage(swatch);
        this.bindSwatchEvents(swatch, swatch_list, image, org_srcset);
      });
    }

    preloadSwatchImage(swatch) {
      const srcset = swatch.dataset.srcset;
      if (!srcset) return;
      const preload = () => { new Image().srcset = srcset; };
      document.readyState === 'complete'
        ? preload()
        : window.addEventListener('load', preload, { once: true });

      const secondarySrcset = this.resolveProductCardSrcset(swatch.dataset.secondarySrcset);
      if (secondarySrcset) {
        const preloadSecondary = () => { new Image().srcset = secondarySrcset; };
        document.readyState === 'complete'
          ? preloadSecondary()
          : window.addEventListener('load', preloadSecondary, { once: true });
      }
    }

    swapImage(imgEl, srcset) {
      if (!imgEl || !srcset) return;
      const temp = new Image();
      temp.srcset = srcset;
      const apply = () => {
        imgEl.setAttribute('srcset', srcset);
        imgEl.setAttribute('data-srcset', srcset);
      };
      temp.complete ? apply() : (temp.onload = temp.onerror = apply);
    }

    getVariantJson() {
      if (this._variantJson) return this._variantJson;
      const script = this.querySelector('.product-card-variants-json');
      if (!script) return null;
      try {
        this._variantJson = JSON.parse(script.textContent || '{}');
      } catch (e) {
        this._variantJson = null;
      }
      return this._variantJson;
    }

    formatMoney(cents, options = {}) {
      const { forceDecimals = false } = options;

      const themeSettings = window.theme && window.theme.settings;
      const format =
        (themeSettings && themeSettings.money_with_currency_format) ||
        window.moneyFormat ||
        null;

      if (typeof window.formatMoney === 'function' && format) {
        const formatted = window.formatMoney(cents, format);
        return forceDecimals ? formatted : this.stripMoneyTrailingZeros(formatted);
      }

      const value = Math.round(cents || 0) / 100;
      return forceDecimals ? value.toFixed(2) : String(Math.round(value));
    }

    stripMoneyTrailingZeros(formatted) {
      if (typeof formatted !== 'string') return formatted;
      return formatted
        .replace(/([.,]\d*?[1-9])0+(\D*)$/, '$1$2')
        .replace(/[.,]0+(\D*)$/, '$1');
    }

    getSelectedOptionsFromSwatches() {
      const selected = [];

      this.swatches.forEach((container) => {
        const optionIndex = parseInt(container.dataset.index, 10);
        if (Number.isNaN(optionIndex)) return;

        const active = container.querySelector('.product-card-swatch.active');
        if (!active) return;

        const value =
          active.dataset.optionValue ||
          active.querySelector('.visually-hidden')?.innerText.trim() ||
          active.innerText.trim();

        if (value) {
          selected[optionIndex] = value;
        }
      });

      return selected;
    }

    findVariantFromJson(selectedOptions) {
      const data = this.getVariantJson();
      if (!data) return null;
      let found = null;

      Object.keys(data).some((id) => {
        const v = data[id];
        const isMatch = selectedOptions.every((opt, index) => {
          if (!opt) return true;
          const key = `option${index + 1}`;
          return v[key] === opt;
        });
        if (isMatch) {
          found = { id, data: v };
          return true;
        }
        return false;
      });

      return found;
    }

    updatePriceFromVariant(variantData) {
      if (!variantData) return;

      const priceContainer =
        this.querySelector('.product-card-info-cart-content .price') ||
        this.querySelector('.product-card-info .price');
      if (!priceContainer) return;

      const priceCents = variantData.price;
      const compareCents = variantData.compare_at_price;

      const delEl = priceContainer.querySelector('del');
      const delAmount = delEl && delEl.querySelector('.amount');
      const insAmount = priceContainer.querySelector('ins .amount');

      const forceDecimals = priceContainer.dataset.forceDecimals === 'true';

      const applyFormat = (amountEl, cents) => {
        if (!amountEl || typeof cents !== 'number') return;
        amountEl.textContent = this.formatMoney(cents, { forceDecimals });
      };

      if (insAmount && typeof priceCents === 'number') {
        applyFormat(insAmount, priceCents);
      }

      if (delEl && delAmount) {
        if (typeof compareCents === 'number' && compareCents > priceCents) {
          applyFormat(delAmount, compareCents);
          delEl.style.display = '';
        } else {
          delEl.style.display = 'none';
        }
      }
    }

    updateNotExistForOption(activeOptionIndex, selectedOptions) {
      const data = this.getVariantJson();
      if (!data) return;

      const variants = Object.values(data);
      const activeValue = selectedOptions[activeOptionIndex];
      if (!activeValue) return;

      const maxOptions = 2; // usamos option1 e option2 do JSON

      for (let otherIndex = 0; otherIndex < maxOptions; otherIndex += 1) {
        if (otherIndex === activeOptionIndex) continue;

        const possibleValues = new Set();

        variants.forEach((v) => {
          const opts = [v.option1, v.option2];
          if (opts[activeOptionIndex] === activeValue) {
            if (opts[otherIndex]) {
              possibleValues.add(opts[otherIndex]);
            }
          }
        });

        const otherContainer = Array.from(this.swatches).find(
          (c) => parseInt(c.dataset.index, 10) === otherIndex,
        );
        if (!otherContainer) continue;

        otherContainer.querySelectorAll('.product-card-swatch').forEach((swatch) => {
          const val =
            swatch.dataset.optionValue ||
            swatch.querySelector('.visually-hidden')?.innerText.trim() ||
            swatch.innerText.trim();

          if (!val) return;

          const exists = possibleValues.has(val);
          swatch.classList.toggle('not-exist', !exists);
        });
      }
    }

    bindSwatchEvents(swatch, swatch_list, image, org_srcset) {
      const activate = () => this.onSwatchActivate(swatch, swatch_list, image, org_srcset);
      const variantSwitchOnHover = this.dataset.variantSwitchOnHover === 'true'

      if (this.there_is_variant_switch_control && !variantSwitchOnHover) {
        swatch.addEventListener('click', activate);
      } else if (window.matchMedia('(hover: hover)').matches) {
        swatch.addEventListener('mouseover', activate);
      } else {
        swatch.addEventListener('touchstart', activate);
      }

      if (!this.is_recommendation && !this.there_is_variant_switch_control) {
        swatch.addEventListener('click', (evt) => {
          evt.preventDefault();
          window.location.href = swatch.dataset.href;
        });
      }
    }

    onSwatchActivate(swatch, swatch_list, image, org_srcset) {
      [].forEach.call(swatch_list, function (el) {
        el.classList.remove('active');
      });
      swatch.classList.add('active');

      const selectedOptions = this.getSelectedOptionsFromSwatches();
      const matched = this.findVariantFromJson(selectedOptions);
      const variantsById = this.getVariantJson() || {};
      const variantIdFromSwatch = swatch.dataset.variantId;
      const selectedVariantData =
        (variantIdFromSwatch && variantsById[variantIdFromSwatch]) ||
        (matched && matched.data) ||
        null;
      if (selectedVariantData) {
        this.updatePriceFromVariant(selectedVariantData);
      }
      this.verifySwatchAvailability();

      let newSrcset = swatch.dataset.srcset || org_srcset;

      if (matched && matched.data && matched.data.featured_image && !swatch.dataset.srcset) {
        const src = matched.data.featured_image;
        const widths = this.there_is_variant_switch_control ? [100, 200, 300, 400] : [400, 500, 700];
        newSrcset = this.buildProductCardSrcset(src, widths);
      }

      this.swapImage(image, newSrcset);
      const secondaryImage = this.querySelector('.product-secondary-image');
      if (secondaryImage) {
        let newSecondarySrcset = this.resolveProductCardSrcset(swatch.dataset.secondarySrcset);
        if (matched && matched.data && matched.data.secondary_image) {
          newSecondarySrcset = this.resolveProductCardSrcset(matched.data.secondary_image);
        }
        if (newSecondarySrcset) {
          this.swapImage(secondaryImage, newSecondarySrcset);
          secondaryImage.style.display = '';
        }
      }

      const variantIdForButton = matched ? matched.id : swatch.dataset.variantId;
      if (this.quick_add && variantIdForButton) {
        this.quick_add.dataset.productId = variantIdForButton;
      }

      if (this.size_options && this.current_options) {
        this.current_options[this.color_index] = swatch.querySelector('span').innerText;
        this.updateMasterId();
      }

      if (this.is_recommendation) {
        const cardItem = this.closest('li.bundle-item');
        if (cardItem) {
          const variantId = matched ? matched.id : swatch.dataset.variantId;
          cardItem.dataset.variantId = variantId;
          const recommendationsEl = this.closest('product-recommendations');
          const strip = recommendationsEl && recommendationsEl.querySelector('[data-selected-images]');
          if (strip) {
            const bundleItems = recommendationsEl.querySelectorAll('.bundle-item');
            const index = [].indexOf.call(bundleItems, cardItem);
            const slot = strip.querySelector(`.product-recommendations__selected-image-item[data-bundle-index="${index}"]`);
            const stripImg = slot && slot.querySelector('.product-primary-image');
            if (stripImg) {
              const srcset = newSrcset || swatch.dataset.srcset || org_srcset;
              stripImg.setAttribute('srcset', srcset);
              stripImg.setAttribute('data-srcset', srcset);
            }
          }
        }
      }
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);

      const quantityInput = this.querySelector('quantity-selector .qty');
      let quantity = 1;
      if (quantityInput) {
        const parsed = parseInt(quantityInput.value, 10);
        if (!Number.isNaN(parsed) && parsed > 0) {
          quantity = parsed;
        }
      }
      formData.append('quantity', quantity);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.side-panel-footer',
        fallbackSelector: '.cart-drawer'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.side-panel-content .product-cart-item--container',
        fallbackSelector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      },
      {
        id: 'custom-cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        const rootElement = document.getElementById(section.id);
        if (!rootElement) {
          return;
        }
        const sectionHtml = parsedState.sections?.[section.section];
        const sectionUpdate = this.getSectionUpdate(rootElement, sectionHtml, section.selector, section.fallbackSelector);
        if (!sectionUpdate) {
          return;
        }
        sectionUpdate.elementToReplace.innerHTML = sectionUpdate.innerHTML;

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        scrollCartDrawerToTop();
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionUpdate(rootElement, html, selector = '.shopify-section', fallbackSelector = null) {
      if (!html) {
        return null;
      }
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const sourceSpecific = parsedHTML.querySelector(selector);
      const targetSpecific = rootElement.querySelector(selector);
      if (sourceSpecific && targetSpecific) {
        return {
          elementToReplace: targetSpecific,
          innerHTML: sourceSpecific.innerHTML
        };
      }

      if (!fallbackSelector) {
        return null;
      }

      const sourceFallback = parsedHTML.querySelector(fallbackSelector);
      const targetFallback = rootElement.matches(fallbackSelector) ? rootElement : rootElement.querySelector(fallbackSelector);
      if (sourceFallback && targetFallback) {
        return {
          elementToReplace: targetFallback,
          innerHTML: sourceFallback.innerHTML
        };
      }

      return null;
    }
  }

  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
}

/**
 *  @class
 *  @function ProductCardSleep
 */
if (!window.ProductCardSleep) {
  window.ProductCardSleep = class ProductCardSleep extends ProductCard {

    bindSwatchEvents(swatch, swatch_list, image, org_srcset) {
      const activate = () => this.onSwatchActivate(swatch, swatch_list, image, org_srcset);
      const variantSwitchOnHover = this.dataset.variantSwitchOnHover === 'true';

      if (variantSwitchOnHover) {
        if (window.matchMedia('(hover: hover)').matches) {
          swatch.addEventListener('mouseover', activate);
        } else {
          swatch.addEventListener('touchstart', activate, { passive: true });
        }
        swatch.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (swatch.dataset.href) {
            window.location.href = swatch.dataset.href;
          }
        });
      } else {
        swatch.addEventListener('click', (evt) => {
          evt.preventDefault();
          activate();
        });
      }
    }

    onSwatchActivate(swatch, swatch_list, image, org_srcset) {
      [].forEach.call(swatch_list, function (el) {
        el.classList.remove('active');
      });
      swatch.classList.add('active');

      const selectedOptions = this.getSelectedOptionsFromSwatches();
      const matched = this.findVariantFromJson(selectedOptions);
      const variantsById = this.getVariantJson() || {};
      const variantIdFromSwatch = swatch.dataset.variantId;
      const selectedVariantData =
        (variantIdFromSwatch && variantsById[variantIdFromSwatch]) ||
        (matched && matched.data) ||
        null;
      if (selectedVariantData) {
        this.updatePriceFromVariant(selectedVariantData);
      }
      this.verifySwatchAvailability();

      let newSrcset = swatch.dataset.srcset || org_srcset;
      let newSecondarySrcset = null;

      if (selectedVariantData) {
        if (selectedVariantData.sleep_primary_srcset) {
          newSrcset = selectedVariantData.sleep_primary_srcset;
        }
        if (selectedVariantData.sleep_secondary_srcset) {
          newSecondarySrcset = selectedVariantData.sleep_secondary_srcset;
        }
      }

      this.swapImage(image, newSrcset);

      const secondaryImage = this.querySelector('.product-secondary-image');
      if (secondaryImage) {
        if (newSecondarySrcset) {
          this.swapImage(secondaryImage, newSecondarySrcset);
          secondaryImage.style.display = '';
        } else {
          secondaryImage.style.display = 'none';
        }
      }

      const variantIdForButton = variantIdFromSwatch || (matched ? matched.id : null);
      if (this.quick_add && variantIdForButton) {
        this.quick_add.dataset.productId = variantIdForButton;
      }

      let variantHref = swatch.dataset.href || '';
      if (variantIdForButton) {
        const productLink = this.querySelector('.product-card--featured-image-link[data-product-url], .product-card-title[data-product-url]');
        const productUrlBase = productLink && productLink.dataset.productUrl;
        if (productUrlBase) {
          try {
            const url = new URL(productUrlBase, window.location.origin);
            url.searchParams.set('variant', variantIdForButton);
            variantHref = `${url.pathname}${url.search}${url.hash}`;
          } catch (e) {
            // Keep existing swatch href when URL parsing fails.
          }
        }
      }
      if (variantHref) {
        this.querySelectorAll('.product-card--featured-image-link, .product-card-title').forEach((link) => {
          link.setAttribute('href', variantHref);
        });
      }

      if (this.size_options && this.current_options) {
        this.current_options[this.color_index] = swatch.querySelector('span').innerText;
        this.updateMasterId();
      }
    }

  }

  if (!customElements.get('product-card-sleep')) {
    customElements.define('product-card-sleep', ProductCardSleep);
  }
}

/**
 *  @class
 *  @function ProductCardForLP
 */
if (!window.ProductCardForLP) {
  window.ProductCardForLP = class ProductCardForLP extends ProductCard {
    constructor() {
      super();
      this.card_product_id = this.dataset.productId;
      this.anchor_buttons = this.querySelectorAll(`#anchor-button-${this.card_product_id}`);
      this.anchor_button_section_id = this.dataset.anchorButtonSectionId;
      this.product_handle = this.dataset.productHandle;
    }
    connectedCallback() {
      super.connectedCallback();

      if (this.anchor_buttons) {
        this.enableAnchorButton();
      }
      if (this.querySelector('.product-card-swatches--color-material-label--lp')) {
        requestAnimationFrame(() => this.updateColorMaterialLabel());
      }
    }
    bindSwatchEvents(swatch, swatch_list, image, org_srcset) {
      const activate = () => {
        this.onSwatchActivate(swatch, swatch_list, image, org_srcset);
        this.afterSwatchClick(swatch, image, org_srcset);
      };
      const variantSwitchOnHover = this.dataset.variantSwitchOnHover === 'true';

      if (variantSwitchOnHover) {
        if (window.matchMedia('(hover: hover)').matches) {
          swatch.addEventListener('mouseover', activate);
        } else {
          swatch.addEventListener('touchstart', activate, { passive: true });
        }
        swatch.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (swatch.dataset.href) {
            window.location.href = swatch.dataset.href;
          }
        });
      } else {
        swatch.addEventListener('click', () => {
          activate();
        });
      }
    }
    afterSwatchClick(swatch, image, org_srcset) {
      const srcset = swatch.dataset.srcset || org_srcset;

      if (image) {
        image.setAttribute('srcset', srcset);

        if (this.anchor_buttons) {
          this.anchor_buttons.forEach((anchor_button) => {
            anchor_button.dataset.featuredImageUrl = srcset;
          });
        }
      }

      swatch.classList.add('active');

      if (this.quick_add) {
        this.quick_add.dataset.productId = swatch.dataset.variantId;
        this.quick_add.dataset.productHandle = swatch.dataset.variantHandle;
      }

      if (this.anchor_buttons) {
        this.anchor_buttons.forEach((anchor_button) => {
          anchor_button.dataset.productId = swatch.dataset.variantId;
          anchor_button.dataset.productHandle = swatch.dataset.variantHandle;
        });
      }
      this.updateColorMaterialLabel();
    }

    updateColorMaterialLabel() {
      const labelEl = this.querySelector('.product-card-swatches--color-material-label--lp');
      if (!labelEl) return;
      const scriptEl = this.querySelector('.product-card-swatches--variants-colors-json');
      if (!scriptEl) return;
      let variantsData;
      try {
        variantsData = JSON.parse(scriptEl.textContent || '{}');
      } catch (e) {
        return;
      }
      if (!variantsData.variants?.length) return;
      const container = this.querySelector('.product-card-swatches--container');
      if (!container) return;
      const activeSwatch = container.querySelector('.product-card-swatch.active');
      const selectedValue = activeSwatch?.dataset?.optionValue?.trim() ||
        activeSwatch?.querySelector('.visually-hidden')?.textContent?.trim() ||
        activeSwatch?.innerText?.trim();
      const matchedVariant = this.findMatchedVariantForLabel(variantsData, selectedValue);
      const html = this.buildColorMaterialLabelHTML(matchedVariant, selectedValue);
      labelEl.innerHTML = html;
    }

    findMatchedVariantForLabel(variantsData, selectedValue) {
      if (!selectedValue) return null;
      for (const variantColor of variantsData.variants) {
        if (variantColor.metaobject_colors?.values) {
          for (const color of variantColor.metaobject_colors.values) {
            if (color.label === selectedValue) return variantColor;
          }
        }
      }
      return null;
    }

    buildColorMaterialLabelHTML(matchedVariant, selectedValue) {
      const escapeHTML = (str) => {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      };
      const normalizeTitle = (title) => {
        if (!title) return '';
        const normalized = escapeHTML(title).trim();
        return normalized.endsWith(':') ? normalized.slice(0, -1) : normalized;
      };
      let html = '';
      if (matchedVariant) {
        const hasMaterial = matchedVariant.title_material && matchedVariant.content_material;
        const hasColorTitle = matchedVariant.title_color?.trim();
        const separator = matchedVariant.separator || '|';
        if (hasMaterial) {
          const materialLabel = `<strong>${normalizeTitle(matchedVariant.title_material)}:</strong>`;
          const materialValue = `<span class="form__label__material-value">${escapeHTML(matchedVariant.content_material)}</span>`;
          const separatorHTML = (hasColorTitle || selectedValue) && separator
            ? ` <span class="form__label__separator">${escapeHTML(separator)}</span> ` : '';
          html += `<span class="form__label__material-section">${materialLabel} ${materialValue}${separatorHTML}</span>`;
        }
        if (hasColorTitle || (!matchedVariant.title_material && selectedValue)) {
          const colorTitle = hasColorTitle ? normalizeTitle(matchedVariant.title_color) : 'Color';
          const colorLabel = `<strong>${colorTitle}:</strong>`;
          const colorValue = `<span class="form__label__color-value">${escapeHTML(selectedValue)}</span>`;
          html += (html ? ' ' : '') + `<span class="form__label__color-section">${colorLabel} ${colorValue}</span>`;
        }
      } else if (selectedValue) {
        html = `<strong>Color:</strong> <span class="form__label__color-value">${escapeHTML(selectedValue)}</span>`;
      }
      return html;
    }

    enableAnchorButton() {
      this.anchor_buttons.forEach((anchor_button) => {
        anchor_button.addEventListener('click', this.anchorButton.bind(this));
      });
    }

    newErrorMessage(message) {
      this.getBackgroundLoading.classList.add('is-hidden');
      this.showErrorTooltip();
      throw new Error(message);
    }

    showErrorTooltip() {
      const existingTooltip = document.querySelector('.error-tooltip');
      if (existingTooltip) {
        existingTooltip.remove();
      }

      const tooltip = document.createElement('div');
      tooltip.className = 'error-tooltip';
      tooltip.textContent = theme.errors.somethingWentWrong;

      tooltip.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background-color: #ff4444;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10000;
        font-size: 14px;
        font-weight: 500;
        opacity: 0;
        transform: translateY(-10px);
        transition: opacity 0.3s ease, transform 0.3s ease;
        pointer-events: none;
      `;

      document.body.appendChild(tooltip);

      requestAnimationFrame(() => {
        tooltip.style.opacity = '1';
        tooltip.style.transform = 'translateY(0)';
      });

      setTimeout(() => {
        tooltip.style.opacity = '0';
        tooltip.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          tooltip.remove();
        }, 300);
      }, 3000);
    }

    async fetchNewProductData(url) {
      return fetch(url)
        .then((response) => response.json())
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    }

    async anchorButton(e) {
      this.getBackgroundLoading = document.querySelector('.list-products .loading-overlay-container');
      this.getBackgroundLoading.classList.remove('is-hidden');

      this.featuredProductLpSection = document.querySelector(`#${this.anchor_button_section_id}`);
      if (!this.featuredProductLpSection) this.newErrorMessage('Featured product LP section not found');

      this.anchorButtonTarget = e.target.closest('[id^="anchor-button-"]');
      if (!this.anchorButtonTarget) this.newErrorMessage('Anchor button target not found');

      const productHandle = this.anchorButtonTarget.dataset.productHandle;
      const variantId = this.anchorButtonTarget.dataset.productId;
      const sectionId = this.featuredProductLpSection.dataset.id;

      const url = new URL(window.location.href);
      url.searchParams.set('fetch_featured_product', productHandle);

      if (variantId) url.searchParams.set('fetch_featured_variant', variantId);
      else url.searchParams.delete('fetch_featured_variant');

      url.searchParams.set('sections', sectionId);

      const productData = await this.fetchNewProductData(url.toString());
      if (!productData) this.newErrorMessage('Product data not found');

      const newHtml = new DOMParser().parseFromString(productData[sectionId], 'text/html');
      if (!newHtml) this.newErrorMessage('HTML not found');

      const oldRoot = this.featuredProductLpSection.querySelector('.product-grid-container');
      const newRoot = newHtml.querySelector('.product-grid-container');

      if (!oldRoot || !newRoot) this.newErrorMessage('Product grid container not found');

      oldRoot.replaceWith(newRoot);

      this.getBackgroundLoading.classList.add('is-hidden');
    }
  }

  if (!customElements.get('product-card-for-lp')) {
    customElements.define('product-card-for-lp', ProductCardForLP);
  }
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      const buttons = document.querySelectorAll('#cart-drawer-toggle, #custom-cart-drawer-toggle');

      // Add functionality to buttons
      buttons.forEach((button) => {
        if (button.id === 'custom-cart-drawer-toggle') {
          this.classList.add('secondary-cart-custom-header');
        }
        button.addEventListener('click', (e) => {
          e.preventDefault();
          document.body.classList.add('open-cc');
          document.body.classList.add('open-cart');
          this.classList.add('active');
          this.focus();
          setTimeout(() => {
            this.querySelector('.product-recommendations--full')?.classList.add('active');
          });
          dispatchCustomEvent('cart-drawer:open');
        });
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      const sections = [
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-footer',
          fallbackSelector: '.cart-drawer'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.side-panel-content .product-cart-item--container',
          fallbackSelector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
      if (this.classList.contains('secondary-cart-custom-header')) {
        sections.push({
          id: 'custom-cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        });
      }
      return sections;
    }
    getSectionUpdate(rootElement, html, selector, fallbackSelector = null) {
      if (!html) {
        return null;
      }
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const sourceSpecific = parsedHTML.querySelector(selector);
      const targetSpecific = rootElement.querySelector(selector);
      if (sourceSpecific && targetSpecific) {
        return {
          elementToReplace: targetSpecific,
          innerHTML: sourceSpecific.innerHTML
        };
      }

      if (!fallbackSelector) {
        return null;
      }

      const sourceFallback = parsedHTML.querySelector(fallbackSelector);
      const targetFallback = rootElement.matches(fallbackSelector) ? rootElement : rootElement.querySelector(fallbackSelector);
      if (sourceFallback && targetFallback) {
        return {
          elementToReplace: targetFallback,
          innerHTML: sourceFallback.innerHTML
        };
      }

      return null;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const rootElement = document.getElementById(section.id);
            if (!rootElement) {
              return;
            }
            if (parsedState.sections) {
              const sectionHtml = parsedState.sections[section.section];
              const sectionUpdate = this.getSectionUpdate(rootElement, sectionHtml, section.selector, section.fallbackSelector);
              if (!sectionUpdate) {
                return;
              }
              sectionUpdate.elementToReplace.innerHTML = sectionUpdate.innerHTML;
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const rootElement = document.getElementById(section.id);
            if (!rootElement) {
              return;
            }
            const sectionHtml = parsedState[section.section];
            const sectionUpdate = this.getSectionUpdate(rootElement, sectionHtml, section.selector, section.fallbackSelector);
            if (!sectionUpdate) {
              return;
            }
            sectionUpdate.elementToReplace.innerHTML = sectionUpdate.innerHTML;
          }));

          this.removeProductEvent();
          this.notesToggle();
          scrollCartDrawerToTop();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
      // A row starting closed, or hidden on this device, must not play behind its own summary
      this.setVideoState(this.details.open);
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    // Videos only run while the row is open, autoplaying ones picking up where they left off.
    // A row hidden by hide_on_mobile or hide_on_desktop counts as closed: display none stops
    // nothing on its own, so an invisible row would keep a video loading and playing.
    setVideoState(open) {
      const playable = open && this.offsetParent !== null;

      this.querySelectorAll('video').forEach((video) => {
        if (!playable) {
          video.pause();
        } else if (video.autoplay) {
          const playing = video.play();
          if (playing) playing.catch(() => {});
        }
      });
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;
      this.setVideoState(false);

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      this.setVideoState(true);
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

// Generic animated-details wrapper for reusable animated <details>
if (!customElements.get('animated-details')) {
  class AnimatedDetails extends HTMLElement {
    constructor() {
      super();
      this.duration = 300;
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.summary = this.details.querySelector('summary');
      this.content =
        this.details.querySelector('.sub-menu, [data-animated-content]') ||
        this.details.lastElementChild;

      if (!this.summary || !this.content) return;

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      this.content.style.overflow = 'hidden';
      if (!this.details.open) {
        this.content.style.height = '0px';
      } else {
        this.content.style.height = this.content.scrollHeight + 'px';
      }

      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.content.offsetHeight}px`;
      const endHeight = '0px';

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.content.animate(
        { height: [startHeight, endHeight] },
        { duration: this.duration, easing: 'ease' },
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.content.offsetHeight}px` || '0px';
      const endHeight = `${this.content.scrollHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.content.animate(
        { height: [startHeight, endHeight] },
        { duration: this.duration, easing: 'ease-out' },
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.content.style.height = open ? '' : '0px';
    }
  }
  customElements.define('animated-details', AnimatedDetails);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});